import * as React from 'react';
import { DropTarget, DragSource } from 'react-dnd';

import { IDocument, IPage, IDragInfo } from '../../../../../infrastructure/interfaces';
import { placeholderTypes, isRightPageOnlyPlaceholderType } from '../../../../../infrastructure/placeholderTypes';
import { productType } from '../../../../../infrastructure/ProductType';
import PagePlaceholder from './PagePlaceholder';
import DragTypes from '../../../../../infrastructure/DragTypes';
import { LayoutType } from 'src/infrastructure/LayoutTypes';

export interface PageEditorProps {
  lastDroppedItem: { type: number; data: any; accepts: string[]};
  index: number;
  document: IDocument | null;
  page: IPage;
  accepts: string[];
  connectDropTarget?: (element: JSX.Element) => Element;
  connectDragSource?: Function;
  removeProduct?(e: any, index: number): void;
  isOver?: boolean;
  canDrop?: boolean;
  onDrop: (data: any, dragInfo: IDragInfo) => void;
  layout?: string | null;
}

const dustbinSource = {
  beginDrag(props: any) {
    return {
      type: props.type || props.lastDroppedItem.type,
      index: props.index,
    };
  },
  canDrag(props: any) {
    return props.lastDroppedItem.data ||
      props.lastDroppedItem.type === placeholderTypes.TOC ||
      props.lastDroppedItem.type === placeholderTypes.BlankPage
      ? true : false;
  },

};

const dustbinTarget = {
  canDrop(props: any, monitor: any) {
    const item = monitor.getItem();
    const dragIndex = item.index;
    const dropIndex = props.index;

    if (dragIndex === dropIndex) {
      return false;
    }

    if (props.document.type === productType.Catalog) {

      let isSeed = item.data !== undefined && item.data.type === 'Seed';
      const bottomRow: number = 15;

      if(props.page.layout === LayoutType.Agronomy && isSeed === false){
        // Images can be accepted on the slots below the table of seed
        const isImage = (item.data.src != null);
        return (isImage && props.index > bottomRow);
      }

      const product = monitor.getItem();
      const isAgronomy = props.page.layout === LayoutType.Agronomy;
      const topRow = props.page.placeholders[0].data;

      //Forces a user flow where you can only add seeds of the same type to the Agronomy chart, starting with the top row
      if(isAgronomy){
      if((topRow === null) || (topRow.category == null)){
        if(props.index === 0 && monitor.isOver() === true){
          return true;
        } else if(props.index > bottomRow){
          return true;
        } else {
          return false;
        }
      } else {
        if(product.data.category.id === topRow.category.id){
          return true;
        } else if(props.index > bottomRow){
          return true;
        } else {
          return false;
        }
      }
    }

      if (isRightPageOnlyPlaceholderType(item.type)) {
        return props.page.position === 'left' ? false : true;
      }

      //Only let seeds drop on the seed based pages
      if (isSeed && props.page.layout === undefined) {
         return false;
      }
    }
    return true;
  },
  drop(props: any, monitor: any) {
    const item = monitor.getItem();
    const type = monitor.getItemType();
    const dragIndex = item.index;
    const dropIndex = props.index;

    const dragInfo = {
      type,
      dragIndex,
      dropIndex,
    };

    return props.onDrop(item, dragInfo);
  },

};

@DragSource(DragTypes.PLACEHOLDERS, dustbinSource, (connect, monitor) => ({
  connectDragSource: connect.dragSource(),
  isDragging: monitor.isDragging(),
}))

@DropTarget(props => [...props.accepts, DragTypes.PLACEHOLDERS], dustbinTarget, (connect, monitor) => ({
  connectDropTarget: connect.dropTarget(),
  isOver: monitor.isOver(),
  canDrop: (monitor.canDrop() && monitor.isOver()),
  itemType: monitor.getItemType(),
}))
export default class PageEditor extends React.Component<PageEditorProps> {
  constructor(props: PageEditorProps) {
    super(props);
  }

  render() {
    const {
      isOver,
      canDrop,
      lastDroppedItem,
      index,
      document,
      page: { number: pageNumber },
    } = this.props;

    let pagePosition = (((pageNumber != undefined) && (pageNumber % 2)) == 0) ? "left" : "right";

    if(this.props.page.layout === LayoutType.Agronomy) {
      if(this.props.index === 18 || this.props.index === 19) {
        pagePosition = "right";
      } else {
        pagePosition = "left";
      }
    }

    const isActive = isOver && canDrop;
    let templateType = lastDroppedItem.data && lastDroppedItem.data.templateType || null;

    if (document && document.type === 'Bulletin') {
      templateType = 'type2';
    }
    let border = '';
    let className = '';

    if (isActive) {
      border = '2px dashed #72af5f';
      className = 'green';
    } else if (canDrop) {
      border = '2px dashed #eab130';
      className = 'yellow';
    }

    if (isOver && !canDrop) {
      border = '2px dashed red';
      className = 'red';
    }

    let isDropped = '';

    let IsCatalog = (this.props.document !== null && this.props.document.type === productType.Catalog)? "Catalog" : ''

    if (lastDroppedItem.data || this.props.lastDroppedItem.type === 5 || this.props.lastDroppedItem.type === 6) {
      isDropped = 'isDropped';
    }

    if ((this.props.connectDragSource == undefined) || (this.props.connectDropTarget == undefined)) {
      return (<div></div>);
    }

    return this.props.connectDragSource(
      this.props.connectDropTarget(
        <div
          key={pageNumber}
          className={`${this.props.layout} ${className} ${pagePosition} ${IsCatalog} crop-page-view-drop ${
            lastDroppedItem.type === placeholderTypes.Image ||
              lastDroppedItem.type === placeholderTypes.Blank ? 'crop-page-view-image-drop' : ''}
            ${isDropped} ${templateType ? `catalog-product 
            ${templateType}` : ''}`}
          style={{ border }}
          data-pagenumber={pageNumber}
        >
          <PagePlaceholder
            removeProduct={this.props.removeProduct}
            index={index}
            model={lastDroppedItem}
            isEditorView={true}
            pageNumber={pageNumber}
            document={this.props.document}
          />
        </div>),
    );
  }

}



// WEBPACK FOOTER //
// ./src/components/Editor/components/CropPageView/common/PageEditor.tsx